import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
// import FormControl from "@material-ui/core/FormControl";
// import InputLabel from "@material-ui/core/InputLabel";
// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.jsx";
import Add from "@material-ui/icons/Add";
import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";
import { hist } from "../../index";
// import clsx from "clsx";
// import MANAGE_USERS from 'actionTypes/manageUser_actionType';

class HeaderLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      roles: [
        {
          id: "IT_INFRA",
          name: "IT Infra"
        },
        {
          id: "IT",
          name: "IT"
        },
        {
          id: "OPS",
          name: "Ops"
        },
        {
          id: "SPD",
          name: "SPD"
        }
      ]
    };
  }

  // componentWillUnmount() {
  //   this.props.resetInitialData();
  // }

  openAddCategoryForm = () => {
    hist.push("/admin/addusers");
  };

  render() {
    const { classes } = this.props;
    // const { roles } = this.state;
    return (
      <div className="header_main_links manage-offers-header manage-partner-header">
        <div className="new_Card">
          {/* <FormControl
            className={clsx(classes.formControl, "filter-by-offer-code")}
          >
            <InputLabel htmlFor="age-simple">Filter by Role</InputLabel>
            <Select
              value={query.role}
              onChange={event => {
                let newQuery = {
                  role: event.target.value
                };
                updateQueryForUser(newQuery);
              }}
              inputProps={{
                name: "percentage",
                id: "age-simple"
              }}
            >
              <MenuItem value={"all"}>All</MenuItem>
              {roles.map((role, index) => {
                return (
                  <MenuItem key={index} value={role.id}>
                    {role.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl> */}
          <Button
            color="facebook"
            round
            className={classes.marginRight}
            onClick={this.openAddCategoryForm}
          >
            <Add className={classes.icons} /> Add Users
          </Button>
        </div>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool
};

const mapStateToProps = state => {
  // return {
  //   selectedUserRole: state.manageUsers.query.role,
  //   query: state.manageUsers.query
  // };
};

const mapDispatchToProps = dispatch => {
  return {
    // updateQueryForUser: query =>
    //   dispatch({
    //     type: MANAGE_USERS.UPDATE_QUERIES_FOR_GET_USERS,
    //     payload: query
    //   }),
    // resetInitialData: () => {
    //   dispatch({ type: MANAGE_USERS.RESET_INITIAL_DATA });
    // }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(headerLinksStyle)(HeaderLinks));



// WEBPACK FOOTER //
// ./src/components/Header/ManageUsersHeader.jsx